module.exports = __webpack_public_path__ + "img/no-quest.80b33707.svg";